import { render, staticRenderFns } from "./AgeConfirmation.vue?vue&type=template&id=ebe2ac7e&scoped=true"
import script from "./AgeConfirmation.vue?vue&type=script&lang=js"
export * from "./AgeConfirmation.vue?vue&type=script&lang=js"
import style0 from "./AgeConfirmation.vue?vue&type=style&index=0&id=ebe2ac7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe2ac7e",
  null
  
)

export default component.exports